import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type standardToPremiumModalQuery,
} from './__generated__/standardToPremiumModalQuery.graphql';

type EntryPointParams = {
	cloudId: string;
	context: standardToPremiumModalQuery['variables']['context'];
	hamsProductKey: string;
	shouldCheckPaidToTwc: boolean;
};

type StandardToPremiumModalComponent = EntryPointComponent<
	{
		standardToPremiumModalQuery: standardToPremiumModalQuery;
	},
	Record<string, never>,
	{
		onClose: (extraInformation?: unknown) => void;
		onContentSelectionChange: (selection: 'premium' | 'twc') => void;
	},
	{ shouldCheckPaidToTwc: boolean }
>;

export const entryPoint: EntryPoint<StandardToPremiumModalComponent, EntryPointParams> =
	createEntryPoint({
		root: JSResourceForInteraction<StandardToPremiumModalComponent>(
			/* webpackChunkName: "@atlaskit-internal_edition-awareness-standard-to-premium-modal" */ './standard-to-premium-modal',
			{
				moduleId: 'edition-awareness-standard-to-premium-modal',
			},
		),
		getPreloadProps: ({
			cloudId,
			context,
			hamsProductKey,
			shouldCheckPaidToTwc,
		}: EntryPointParams) => ({
			entryPoints: {},
			extraProps: { shouldCheckPaidToTwc },
			queries: {
				standardToPremiumModalQuery: {
					parameters,
					variables: {
						cloudId,
						context,
						hamsProductKey,
						shouldCheckPaidToTwc,
					},
				},
			},
		}),
	});
